import { render, staticRenderFns } from "./programEfficiency.vue?vue&type=template&id=0acaec50&class=programEfficiency"
import script from "./programEfficiency.vue?vue&type=script&lang=js"
export * from "./programEfficiency.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports